import React, { Fragment } from "react";
import { Box, Grid, Typography, useTheme, Divider } from "@mui/material";
import CommonCard from "../../common/components/CommonCard";


const CollegeList = ({
    colleges,
}) => {
    const theme = useTheme();

    return (
        <Fragment>
            <Grid item xs={12} md={6}>
                <CommonCard
                    borderRadius={2}
                    headerContent={
                        <Fragment>
                            <Box p={1.5} display="flex" justifyContent="space-between" alignItems="center">
                                <Typography fontWeight={600}>Target Colleges</Typography>
                            </Box>
                            <Divider />
                        </Fragment>
                    }
                    content={
                        <Fragment>
                            <Grid container spacing={2}>
                                {colleges?.target_colleges?.length > 0 ? colleges?.target_colleges?.map((i, index) => (
                                    <Grid item md={6}>
                                        <CommonCard
                                            key={index}
                                            content={
                                                <Fragment>
                                                    <img src={i?.logo_url || '/Images/college_1.png'} alt="college" width='100%' height="120px" />
                                                    <Box display="flex" justifyContent="space-between" p={0.9}>
                                                        <Box width='80%'>
                                                            <Typography fontWeight={600} fontSize={14}>{i?.college_name}</Typography>
                                                            <Box display="flex" gap={0.3} mt={0.8} alignItems='center'>
                                                                <img src="/Images/location.png" alt="location" width="17px" height="17px" />
                                                                <Typography fontSize={14} color={theme.palette.background.dark}>{`${i?.city}, ${i?.state} ${i?.zipcode}`}</Typography>
                                                            </Box>
                                                        </Box>
                                                        <img src="/Images/target.png" alt="dream college" height="50px" />
                                                    </Box>
                                                </Fragment>
                                            }
                                            border={`1px solid ${theme.palette.background.light}`}
                                            borderRadius={1}
                                            paddingBottom="0px"
                                            padding="0px"
                                            marginTop="0px"
                                        />
                                    </Grid>
                                )) : <Grid item md={12} textAlign="center">
                                    <Typography color={theme.palette.background.dark}>No College Found</Typography>
                                </Grid>}
                            </Grid>
                        </Fragment>
                    }
                    paddingBottom="0px"
                    padding="13px"
                    marginTop="0px"
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <CommonCard
                    borderRadius={2}
                    headerContent={
                        <Fragment>
                            <Box p={1.5} display="flex" justifyContent="space-between" alignItems="center">
                                <Typography fontWeight={600}>Safe Colleges</Typography>
                            </Box>
                            <Divider />
                        </Fragment>
                    }
                    content={
                        <Fragment>
                            <Grid container spacing={2}>
                                {colleges?.safe_colleges?.length > 0 ? colleges?.safe_colleges?.map((i, index) => (
                                    <Grid item md={6}>
                                        <CommonCard
                                            key={index}
                                            content={
                                                <Fragment>
                                                    <img src={i?.logo_url || '/Images/college_1.png'} alt="college" width='100%' height="120px" />
                                                    <Box display="flex" justifyContent="space-between" p={0.9}>
                                                        <Box width='80%'>
                                                            <Typography fontWeight={600} fontSize={14}>{i?.college_name}</Typography>
                                                            <Box display="flex" gap={0.3} mt={0.8} alignItems='center'>
                                                                <img src="/Images/location.png" alt="location" width="17px" height="17px" />
                                                                <Typography fontSize={14} color={theme.palette.background.dark}>{`${i?.city}, ${i?.state} ${i?.zipcode}`}</Typography>
                                                            </Box>
                                                        </Box>
                                                        <img src="/Images/safe.png" alt="dream college" height="50px" />
                                                    </Box>
                                                </Fragment>
                                            }
                                            border={`1px solid ${theme.palette.background.light}`}
                                            borderRadius={1}
                                            paddingBottom="0px"
                                            padding="0px"
                                            marginTop="0px"
                                        />
                                    </Grid>
                                )) : <Grid item md={12} textAlign="center">
                                    <Typography color={theme.palette.background.dark}>No College Found</Typography>
                                </Grid>
                                }
                            </Grid>
                        </Fragment>
                    }
                    paddingBottom="0px"
                    padding="13px"
                    marginTop="0px"
                />
            </Grid>
        </Fragment>
    )
}

export default CollegeList;